import React from 'react';
import { observer } from 'mobx-react-lite';
import { TabSubtitle } from '../../../panels/entity-panels/tabs/tab-subtitle';
import { Button } from '@cad-arc';
import { useEventMetadataStore } from '../../event-panel-form/event-metadata';
import { PhoneCallInfoDisplay } from './phone-call-info-display';
import { useCallImport } from './use-call-import';
import { usePhoneCallForEvent } from './get-phone-call-for-event';

export const AniAliSection = observer(function AniAliSection(): React.ReactElement | null {
    const eventMetadata = useEventMetadataStore().state.metadata;
    const eventExists = !!eventMetadata?.eventId;
    const selectedCall = usePhoneCallForEvent();
    const callImport = useCallImport(eventExists);
    if (!selectedCall) {
        return null;
    }
    return (
        <>
            <TabSubtitle
                subtitleTrailingNode={
                    <Button
                        isDisabled={eventExists}
                        trailingVisual="TransmitData"
                        variant="ghost"
                        size="sm"
                        onClick={() => {
                            callImport.importAll(selectedCall);
                        }}
                    >
                        Import All
                    </Button>
                }
            >
                E911
            </TabSubtitle>
            <PhoneCallInfoDisplay
                eventExists={eventExists}
                selectedCall={selectedCall}
                phoneCall={selectedCall}
            />
        </>
    );
});
